import { h } from 'preact';

export const BadgeTrophyIcon = ({ ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.9268 3.2002C16.5419 3.20021 17.0873 3.48555 17.4443 3.92773H18.7969C19.9415 3.92773 20.8623 4.85991 20.8623 6V6.90918C20.8622 7.97537 20.495 9.00922 19.8223 9.83496C19.263 10.5214 18.5209 11.0282 17.6875 11.3008C17.4662 12.1541 17.0606 12.9504 16.4902 13.627C15.942 14.2773 15.2595 14.7952 14.4951 15.1543L14.5791 16.2598C15.4217 16.3902 16.2942 17.0586 16.417 18.1094H17.2598C17.5724 18.1094 17.8736 18.2185 18.1123 18.415L18.2109 18.5049L18.2998 18.6035C18.4949 18.843 18.6024 19.1433 18.6025 19.4541C18.6025 19.8095 18.4622 20.1516 18.2109 20.4043C17.9595 20.6571 17.6172 20.7998 17.2598 20.7998H6.77441C6.41693 20.7998 6.07464 20.6571 5.82324 20.4043C5.57211 20.1516 5.43164 19.8094 5.43164 19.4541C5.43176 19.099 5.57224 18.7574 5.82324 18.5049L5.92188 18.415C6.16061 18.2183 6.46163 18.1094 6.77441 18.1094H7.61719C7.74007 17.0593 8.61342 16.3904 9.45508 16.2598L9.53906 15.1543C8.77123 14.7934 8.08647 14.2718 7.53711 13.6172C6.96327 12.9334 6.556 12.1287 6.33789 11.2666C5.52606 10.9804 4.80709 10.4705 4.2666 9.79004C3.61654 8.97149 3.26272 7.95549 3.2627 6.90918V6C3.2627 4.85991 4.18345 3.92773 5.32812 3.92773H6.58984C6.94678 3.48553 7.49238 3.20034 8.10742 3.2002H15.9268ZM17.8799 7.94043C18.0732 7.63282 18.1777 7.27572 18.1777 6.90918V6.61816H17.8799V7.94043ZM5.94727 6.90918C5.94727 7.2142 6.0196 7.51295 6.15527 7.78223V6.61816H5.94727V6.90918Z"
      fill="#FFE14A"
      stroke="white"
      strokeWidth="1.6"
    />
    <path
      d="M15.645 5.59998C16.187 7.46664 16.5393 11.68 13.6125 13.6"
      stroke="white"
      strokeWidth="0.8"
      strokeLinecap="round"
    />
    <path
      d="M13.6125 17.6C14.1458 17.6 14.8125 17.84 14.8125 18.8"
      stroke="white"
      strokeWidth="0.8"
      strokeLinecap="round"
    />
  </svg>
);
